export const scheduledPostsKeys = {
  article: (articleId: string) => ['scheduledPosts', 'article', articleId],
  show: (postId: number) => ['scheduledPosts', 'show', postId],
  index: (workspaceId: number, filter?: string) => {
    const baseKey = ['scheduledPosts', 'index', workspaceId]

    if (filter) {
      return [...baseKey, filter]
    }

    return baseKey
  },
  calendar: (workspaceId: number, filter?: string) => {
    const baseKey = ['scheduledPosts', 'calendar', workspaceId]

    if (filter) {
      return [...baseKey, filter]
    }

    return baseKey
  },
  unscheduledArticles: ['unscheduledArticles'],
}
